import noop from "./lib/core/functional/noop";
import { isUserLoggedIn, updateLoggedIn } from "./utils/loggedInControl.js";

const error = new Error("User is not logged in");
const waiters = [];
const listeners = [];

function upgrade(context) {
    if (isUserLoggedIn()) {
        import("./upgradeToLoggedIn").then((module) => module.default(context, waiters, listeners));
    }
}

export function doUpgradeToLoggedIn(context) {
    if (isUserLoggedIn()) {
        return context;
    }
    updateLoggedIn(true, context);
    upgrade(context);
    return context;
}

export default function upgradeToLoggedInExperienceLoader(context) {
    context.refreshUserInfo = noop;
    context.getUserInfo = () =>
        new Promise((resolve, reject) => {
            if (isUserLoggedIn()) {
                waiters.push([resolve, reject]);
            } else {
                reject(error);
            }
        });

    context.listenForUserInfo = (cb) => {
        listeners.push(cb);
        if (!isUserLoggedIn()) {
            cb(error, null);
        }
    };

    upgrade(context);

    return context;
}
